import { isDefined } from 'notable-common';
import { z } from 'zod';
import { FlowVersionTarget } from '../../../../flow/versionTarget.js';
import { FlowProducedType } from '../../../../flowRun/producedType.js';
import { BaseFlowBlockSchema, FlowBlockReturnTypeSchema } from '../../block.js';
import { FlowBlockType } from '../../type.js';
import { FlowArgumentSchema } from '../shared/flowArgument.js';
/**
 * Structural validation only. flow-api layers on a lookup of the targeted flow's published version,
 * which needs the database and so cannot live here.
 *
 * Shared with skillV2.
 */
export const FlowSubflowV2BlockConfigSchema = z
    .object({
    versionTarget: z.enum(FlowVersionTarget),
    flowId: z.uuid('A valid flow ID is required'),
    flowDefinitionId: z.uuid('A valid flow definition ID is required').optional(),
    arguments: z.array(FlowArgumentSchema),
})
    .refine(({ versionTarget, flowDefinitionId }) => versionTarget !== FlowVersionTarget.SpecificVersion || isDefined(flowDefinitionId), {
    message: `A flow definition must be selected when using versionTarget=${FlowVersionTarget.SpecificVersion}`,
    path: ['flowDefinitionId'],
});
/**
 * Shared with skill v2.
 */
export const FlowSubflowV2BlockBaseSchema = z.object({
    type: z.literal(FlowBlockType.SubFlowV2),
    returnType: FlowBlockReturnTypeSchema(FlowProducedType.Any),
    config: FlowSubflowV2BlockConfigSchema,
});
export const FlowSubflowV2BlockSchema = BaseFlowBlockSchema.extend(FlowSubflowV2BlockBaseSchema.shape);
//# sourceMappingURL=config.js.map